import React from 'react';

export const WhatsAppFloat = () => {
  const handleWhatsAppClick = () => {
    const message = "Hi Sara Realty! I'm interested in learning more about your properties and services.";
    const phoneNumber = '919715472526'; // Sara Realty WhatsApp number
    const whatsappUrl = phoneNumber 
      ? `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
      : `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full shadow-2xl hover:shadow-[#25D366]/50 transition-all duration-300 hover:scale-110 flex items-center justify-center group"
      aria-label="Chat on WhatsApp"
    >
      <svg 
        className="w-8 h-8 group-hover:scale-110 transition-transform" 
        viewBox="0 0 32 32" 
        fill="currentColor"
      >
        <path d="M16.002 3.154c-7.083 0-12.848 5.765-12.848 12.848 0 2.264 0.588 4.392 1.62 6.24l-1.724 6.298 6.453-1.693c1.776 0.964 3.812 1.514 5.976 1.514 7.083 0 12.848-5.765 12.848-12.848s-5.765-12.848-12.848-12.848zM16.002 26.366c-2.089 0-4.036-0.636-5.649-1.724l-0.405-0.241-4.201 1.1 1.121-4.092-0.265-0.421c-1.199-1.905-1.891-4.165-1.891-6.578 0-6.651 5.412-12.063 12.063-12.063s12.063 5.412 12.063 12.063c0 6.651-5.412 12.063-12.063 12.063zM22.402 19.149c-0.361-0.181-2.137-1.054-2.468-1.175-0.331-0.12-0.572-0.181-0.813 0.181s-0.935 1.175-1.146 1.417c-0.211 0.241-0.422 0.271-0.783 0.090s-1.527-0.563-2.908-1.795c-1.074-0.959-1.799-2.143-2.010-2.504s-0.023-0.557 0.159-0.737c0.163-0.163 0.361-0.422 0.542-0.633s0.241-0.361 0.361-0.602c0.12-0.241 0.060-0.452-0.030-0.633s-0.813-1.96-1.114-2.683c-0.293-0.704-0.591-0.608-0.813-0.619-0.211-0.010-0.452-0.012-0.693-0.012s-0.633 0.090-0.964 0.452c-0.331 0.361-1.266 1.236-1.266 3.014s1.296 3.496 1.477 3.737c0.181 0.241 2.553 3.897 6.186 5.466 0.864 0.373 1.539 0.596 2.065 0.763 0.868 0.276 1.657 0.237 2.282 0.144 0.696-0.104 2.137-0.874 2.438-1.718s0.301-1.568 0.211-1.718c-0.090-0.151-0.331-0.241-0.693-0.422z"/>
      </svg>
      <span className="absolute -top-0.5 -right-0.5 w-3 h-3 bg-red-500 rounded-full animate-pulse"></span>
    </button>
  );
};
